import ConflictsHandlerEdit from './ConflictsHandlerEdit'

export default ConflictsHandlerEdit
